import styled from 'styled-components';
const TooltipsMLStyled = styled.div`
  position: ${(props) => (props.isAbsolute ? 'absolute' : '')};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  right: ${(props) => props.right};
  width: 14px;
  z-index: 999;
  .title-icon {
    width: 14px;
    height: 14px;
    color: ${(props) => props.color || '#9e9e9e'};
  }
`;
export default TooltipsMLStyled;
